/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Hyunsu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Oct 30 2023
 **/

export const COLOR_PALETTE_LIST: DesignStuff.WorkGroup.ColorList[] = [
	"deco1",
	"deco2",
	"deco3",
	"deco4",
	"deco5",
	"deco6",
	"deco7",
	"deco8",
	"deco9",
	"deco10",
	"deco11",
	"deco12",
	"deco13",
	"deco14",
	"deco15",
	"deco16",
	"deco17",
	"deco18"
];
